import { NewsletterSectionRow, TableWrapper } from './helpersComponents'
import { propContainerWidth } from './helpersProps'

const SocialMediaIcons = {
    facebook: 'facebook_icon_white.png',
    instagram: 'instagram_icon_white.png',
    twitter: 'twitter_icon_white.png',
    whatsapp: 'whatsapp_icon_white.png',
    tiktok: 'tiktok_icon_white.png'
}

const NewsletterSectionSocialMediaItem = ({
    imageHref,
    imageAlt,
    imageUrl,
    align,
    valign,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight
}) => (
    <td  style={{paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight}} className="imageContent" align={align} valign={valign}>
        <a href={`${imageHref}`} target="_blank">
            <img 
                className={"flexibleImage"}
                align="absbottom" 
                alt={imageAlt} 
                src={imageUrl} 
                width='50'
                height='50'
                style={{maxWidth: '50px', maxHeight: '50px', display: "block", fontSize: 0, lineHeight: 0}}
            />
        </a>
    </td>
)

const NewsletterSectionSocialMedia = ({
    items, 
    currentCinemaUrl,
    paddingTop ="50px",
    paddingBottom = "20px",
    paddingLeft =  "10px",
    paddingRight = "10px",
}) => {   

    const getImgUrl = type => currentCinemaUrl + '/wp-content/themes/pmkino/assets-static/' + SocialMediaIcons[type]

    if(!items) {
        return null
    }

    const types = Object.keys(items).filter(type => items[type])

    if(0 === types.length) {
        return null
    }
    
    return (
        <NewsletterSectionRow 
            width={types.length * 70}
        >
            <TableWrapper>
                <tr>
                    {types.map(type => <NewsletterSectionSocialMediaItem
                        key={type}
                        imageHref={items[type]}
                        imageAlt={type + '-icon'}
                        imageUrl={getImgUrl(type)}
                        align="center"
                        valign="top"
                        paddingTop = {paddingTop}
                        paddingBottom = {paddingBottom}
                        paddingLeft =  {paddingLeft}
                        paddingRight = {paddingRight}
                    />)}
                </tr>
            </TableWrapper>
        </NewsletterSectionRow>
    )
}

export default NewsletterSectionSocialMedia

